<script setup>
import PostsBatchForm from '@frontJs/components/forms/projectManagement/smo/PostsBatchForm.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

const { tenant } = defineProps({
    tenant: {
        type: Object,
        required: true,
    },
    isPlatformConfigured: {
        type: Boolean,
        required: false,
    },
    maxContentLength: {
        type: Number,
        required: true,
    },
    maxMediaCount: {
        type: Number,
        required: true,
    },
    defaultScheduledDate: {
        type: String,
        required: false,
    },
    defaultPublicationTime: {
        type: String,
        required: true,
    },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title>Saisie multiple - SMO - Gestion de projet - Datakepler</title>
    </Head>

    <PageTitle :tenant-name="tenant.name">
        Gestion de projet - SMO - Saisie multiple
    </PageTitle>

    <PostsBatchForm
        :tenant="tenant"
        :is-platform-configured="isPlatformConfigured"
        :max-content-length="maxContentLength"
        :max-media-count="maxMediaCount"
        :default-scheduled-date="defaultScheduledDate"
        :default-publication-time="defaultPublicationTime"
    />
</template>
